import { GridApi } from "@ag-grid-community/core";
import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { LogisticService } from "src/app/modules/logistic/logistic.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-toggle-fbm",
  templateUrl: "./toggle-fbm.component.html",
  styleUrls: ["./toggle-fbm.component.scss"],
})
export class ToggleFbmComponent implements OnDestroy {
  params: any;
  gridApi: GridApi;
  private destroy$ = new Subject<void>();

  constructor(
    private logisticService: LogisticService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    private gridActionsService: GridActionsService
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  action() {
    this.params.action(this.params.data);
  }

  onCheckboxChange(event, data) {
    var value = event.target.checked;
   
    if (data.ItemCount > 0) {
      this.logisticService.WhLocationFBMEnabled(data, value).pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: `WhLocation FBM Enabled updated  successfully`,
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
      });
    } else {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: `Unable to turn on FBM for Location without items`,
            action: 'Dismiss',
            type: 'error',
          },
        });
      this.gridActionsService.refresh();
    }    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
